import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center text-slate-500" data-testid="auth-loading">Caricamento...</div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
